export default __webpack_public_path__ + "static/media/emptyState.d90f02a2.svg";